import { useEffect } from "react";
import { useLang } from "@/i18n/LanguageContext";

export const useLandingMetadata = () => {
  const { t, lang } = useLang();
  useEffect(() => {
    document.title = t.seo.title;
    const content = {
      'meta[name="description"]': t.seo.description,
      'meta[property="og:title"]': t.seo.title,
      'meta[property="og:description"]': t.seo.description,
      'meta[name="twitter:title"]': t.seo.title,
      'meta[name="twitter:description"]': t.seo.description,
      'meta[property="og:locale"]': lang === "da" ? "da_DK" : "en_US",
      'meta[property="og:locale:alternate"]': lang === "da" ? "en_US" : "da_DK",
    };
    Object.entries(content).forEach(([selector, value]) => {
      document.querySelector(selector)?.setAttribute("content", value);
    });
  }, [t, lang]);
};